import React, { memo, useMemo } from 'react';

import { Skeleton } from '@atlassian/eoc-skeleton';

import { type ResponderNameProps } from './types';

const ResponderName: React.FC<ResponderNameProps> = ({ responder, fallback }) => {
	const name = useMemo(
		() => ('name' in responder ? responder.name || responder.id : undefined),
		[responder],
	);

	if (responder.isLoading) {
		return <Skeleton width={5} />;
	}

	return <span>{name || fallback || ''}</span>;
};

export default memo(ResponderName);
